import { render, staticRenderFns } from "./AlertsWrapper.vue?vue&type=template&id=f350e0d8"
import script from "./AlertsWrapper.vue?vue&type=script&lang=js"
export * from "./AlertsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports